function AdminSchoolsLocationsZonesController($state) {

}
AdminSchoolsLocationsZonesController.$inject = ['$state'];

export default AdminSchoolsLocationsZonesController;